import { CheckedChangedEventHandler } from '@sunwebgroup/ui-components'
import { Accordion, IconGlyph } from '@sunwebgroup/ui-components/uds'
import { equals, isEmpty, reject } from 'ramda'
import { useIntl } from '@/intl'
import { ShowMore } from '@/scopes/common/components/ShowMoreUDS'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { useMultiSelectFilter } from '../../../../domain/hooks'
import { FilterGroupProps } from '../types'
import ListFilterItem from './ListFilterItem'

const vacationTypeIconMap: Record<string, IconGlyph> = {
  'ADULTS-ONLY': 'EighteenPlus',
  'CAR_RENTAL_INCLUDED': 'CarRight',
  'BUDGET': 'PigBank',
  'GROUPS': 'ThreePeople',
  'FAMILY': 'Family',
  'FLY_AND_DRIVE': 'CarRight',
  'SHORT_STAY': 'Clock',
  'SMALL_SCALE': 'FaceHappy',
  'ROMANTIC': 'HeartWithSmallerHeart',
  'SPARKY_KIDS_CLUB': 'TwoChildren',
  'SPORTY': 'PersonRunning',
  'CITY_TRIP': 'AppartmentBuilding',
  'WELLNESS_AND_SPA': 'Lotus',
  'BRIDGE': 'SpadeSymbol',
  'GOLF': 'GolfClub',
  'SUSTAINABILITY_LABEL': 'Leaf',
  'LUXURY': 'Diamond',
  'HIKING': 'MountainsSlope',
  'YOUNGSTERS': 'ThreePeople',
}

export function VacationTypeFilter({ defaultOpen }: FilterGroupProps) {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { options, selectedValues, setSelection, isFetching } = useMultiSelectFilter('Themes')

  const handleFilterChange: CheckedChangedEventHandler = ({ checked, value }) => {
    if (checked) {
      setSelection([...selectedValues, value])
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'themes',
          result: [...selectedValues, value].join(','),
        }),
      )
    }
    if (!checked) {
      setSelection(reject(equals(value), selectedValues))
    }
  }

  if (isEmpty(options))
    return null

  return (
    <Accordion.Item title={intl.formatMessage({ id: 'vacation_type_label' })} defaultOpen={defaultOpen} data-qa="vacation-type-filter">
      <ShowMore
        openLabel={intl.formatMessage({ id: 'show_more' })}
        closeLabel={intl.formatMessage({ id: 'show_less' })}
      >
        {options.map(({ name, resultsCount, value }) => (
          <ListFilterItem.Checkbox
            key={name}
            value={value}
            checked={selectedValues.includes(value)}
            label={name}
            counter={resultsCount}
            glyph={vacationTypeIconMap[value]}
            onChange={handleFilterChange}
            disabled={isFetching}
            data-qa="vacation-type-filter-option"
            data-qa-value={value?.toLowerCase()}
          />
        ))}
      </ShowMore>
    </Accordion.Item>
  )
}
